
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class PendriveOutwardDialog extends Serenity.EntityDialog<PendriveOutwardRow, any> {
        protected getFormKey() { return PendriveOutwardForm.formKey; }
        protected getIdProperty() { return PendriveOutwardRow.idProperty; }
        protected getLocalTextPrefix() { return PendriveOutwardRow.localTextPrefix; }
        protected getNameProperty() { return PendriveOutwardRow.nameProperty; }
        protected getService() { return PendriveOutwardService.baseUrl; }
        protected getDeletePermission() { return PendriveOutwardRow.deletePermission; }
        protected getInsertPermission() { return PendriveOutwardRow.insertPermission; }
        protected getUpdatePermission() { return PendriveOutwardRow.updatePermission; }

        protected form = new PendriveOutwardForm(this.idPrefix);

    }
}